import React from 'react';
import PropTypes from 'prop-types';
import {formatPhoneNumberField} from '../util/formatPhoneNumber';
import {EmployeeShape} from '../../../shapes/index';

const EmployeeResult = ({ className='', employee, onClick=()=>{} }) => {
  const cssBEM = 'employee-result';
  const { employeeId, firstName, lastName, email, phone } = employee;

  const renderInitials = () => {
    const firstInitial = firstName ? firstName.charAt(0) : '';
    const lastInitial = lastName ? lastName.charAt(0) : '';
    const initials = `${firstInitial}${lastInitial}`;
    return initials || '?';
  };

  return <div className={`${cssBEM} ${className}`} onClick={ onClick }>
    <div className={`${cssBEM}__initials`}>
      <span>{ renderInitials() }</span>
    </div>
    <div className={`${cssBEM}__fields`}>
      <div className={`${cssBEM}__field ${cssBEM}__name`}>
        <span className={`${cssBEM}__firstName`}>{ firstName }</span>
        <span className={`${cssBEM}__lastName`}>{ lastName }</span>
      </div>
      { employeeId ? <div className={`${cssBEM}__field ${cssBEM}__employeeId`}>{ employeeId }</div> : null }
      <div className={`${cssBEM}__field ${cssBEM}__email`}>{ email }</div>
      <div className={`${cssBEM}__field ${cssBEM}__phone`}>{ formatPhoneNumberField(phone) }</div>
    </div>
  </div>;
};

EmployeeResult.propTypes = {
  className: PropTypes.string,
  employee: EmployeeShape,
  onClick: PropTypes.func
};

export default EmployeeResult;
